import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 45260E4C-E8EB-4E35-85A8-F19A91FE1A2C
 * name skip-backward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-backward.svg
 * tags
 * - Home Automation 
 */
export const SkipBackwardIcon = createSvgIcon(<><path d="M20,5V19L13,12M6,5V19H4V5M13,5V19L6,12" /></>, 'SkipBackwardIcon');
export default SkipBackwardIcon